<!-- 
Table icon buttons.

These are displayed at the top right hand side of tables and include things like a 
refresh button and an export to excel button.
Most buttons will display text and an icon if the screen is big enough, and will shrink
down to just an icon on smaller screens. The refresh and export to json buttons will only
ever display as icons.
-->
<template>
  <span class="text-xs-right">
    <our-icon-button 
      v-if="hasExport" 
      icon="get_app" 
      tooltip="Download all data for the records in this listing as an Excel spreadsheet."
      @click="$emit('click', 'export')"
    >
      Export
    </our-icon-button>
    <our-icon-button 
      v-if="hasExportToJson" 
      icon="save_alt" 
      tooltip="Download the listing to a JSON file"
      @click="$emit('click', 'exportToJson')"
    />
    <template v-if="hasExpanders">
      <our-icon-button
        icon="unfold_more"
        tooltip="Expand all"
        @click="$emit('click', 'expandAll')"
      >
        Expand all
      </our-icon-button>
      <our-icon-button
        icon="unfold_less"
        tooltip="Collapse all"
        @click="$emit('click', 'collapseAll')"
      >
        Collapse all
      </our-icon-button>
      <our-icon-button
        :icon="expandMultiple ? 'toggle_on' : 'toggle_off'"
        :tooltip="expandMultiple ? 'Only allow a single item to be expanded at the one time' : 'Allow multiple items to be expanded'"
        @click="$emit('click', 'toggleMultiple')"
      />
    </template>
    <our-icon-button
      icon="refresh"
      icon-class="refresh-button"
      tooltip="Refresh the listing with the latest data"
      @click="$emit('click', 'refresh')"
    />
  </span>
</template>

<script>
/* 
Standard set of buttons displayed at the top right of our tables.
*/
export default {
  props: {
    hasExport: {
      type: Boolean,
      default: false
    },
    hasExportToJson: {
      type: Boolean,
      default: false
    },
    hasExpanders: {
      type: Boolean,
      default: false
    },
    expandMultiple: {
      type: Boolean,
      default: false
    }
  }
};
</script>
